module.exports = (__webpack_require__(95490))(7350);